import { useAuth, useRequest } from "@onefront/react-sdk";
import { buildHeaders } from "../../../views/common-utils/buildHeaders";
import { useCallback, useState } from "react";

export enum ResponseStatus {
  OK = 200,
  INTERNAL_SERVER_ERROR = 500,
}

interface DataType {
  isUrgent?: boolean;
  key: string;
  read?: boolean;
}

export function usePatchChangeDocumentStatus(): {
  data: DataType;
  error: any;
  fetch: (
    id: string,
    workspaceId: string,
    documentActionChange: DataType
  ) => Promise<ResponseStatus>;
  loading: boolean;
} {
  const [data, setData] = useState<DataType>();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);

  const authData = useAuth();
  const request = useRequest();

  const fetchData = useCallback(
    async (id: string, workspaceId: string, documentActionChange: DataType) => {
      setLoading(true);

      try {
        const { isUrgent, read, key } = documentActionChange;
        const params = new URLSearchParams({ workspaceId });

        if (isUrgent !== undefined) {
          params.append("isUrgent", String(isUrgent));
        }

        if (read !== undefined) {
          params.append("read", String(read));
        }

        await request.fetch({
          headers: buildHeaders({ authData }),
          method: "PATCH",
          lazy: true,
          stateless: true,
          url: `documentsApi://api/v1/documents/change/status/${id}?${params.toString()}`,
        });
        setData({
          isUrgent,
          key,
          read,
        });
        return ResponseStatus.OK;
      } catch (err) {
        console.error(err);
        setError(err);
        return ResponseStatus.INTERNAL_SERVER_ERROR;
      } finally {
        setLoading(false);
      }
    },
    [authData, request]
  );

  return {
    data,
    error,
    fetch: fetchData,
    loading,
  };
}
